import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CustomTextField from '../../../Components/TextField';
import { Box, FormHelperText } from '@mui/material';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { useErrorHandler } from '../../../hooks';
import {
  createExploreCategory,
  getExploreCategory,
} from '../../../Redux/Actions/ExploreAction';
import HelmetReact from '../../../Components/Helmet';
import './style.css';
const AddCategoryModal = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const { setMsgConfig } = useErrorHandler();

  const formik = useFormik({
    initialValues: {
      name: '',
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      name: yup.string().required('Please Enter Category Name'),
    }),
    onSubmit: (values) => {
      let payload = {
        name: formik.values.name,
      };
      dispatch(createExploreCategory(payload));      
      setMsgConfig({
        alertOpen: true,
        message: 'Success!!',
        severity: 'success',
        autoHideDuration: 2000,
      });
      setOpen(!open);
    },
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(!open);
  };

  return (
    <div>
      <HelmetReact name="Explore Category" />
      <Dialog open={open} onClose={handleClose} className="invite-modal">
        <DialogTitle>ADD CATEGORY</DialogTitle>
        <DialogContent>
          <Box>
            <CustomTextField
              className="cname-text"
              label="Category Name"
              name="name"
              fieldType="textInput"
              required
              fullWidth
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder={'Enter category name'}
              error={formik.touched.name && formik.errors.name ? true : false}
            />
            {formik.touched.name && formik.errors.name && (
              <FormHelperText className="error-message">
                {formik.errors.name}
              </FormHelperText>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button className="btn-dark"  variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="btn-dark" variant="contained" onClick={formik.handleSubmit}>
            ADD
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddCategoryModal;
